import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=3312d13a&scoped=true&"
import script from "./step3.vue?vue&type=script&lang=ts&"
export * from "./step3.vue?vue&type=script&lang=ts&"
import style0 from "./step3.vue?vue&type=style&index=0&id=3312d13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3312d13a",
  null
  
)

export default component.exports